//prod
const configProd = {
  urlAbs: "http://www.institutopeninsula.org.br",
  url: "/apoie/",
  pathImages: "/wp-content/themes/saxon-child/apoie/assets/images/"
};

//dev
const configDev = {
  urlAbs: "http://localhost:3000/",
  url: "/",
  pathImages: "/assets/images/"
};

//export default configDev;
export default configProd;
